export var ChargeTypology;
(function (ChargeTypology) {
    ChargeTypology["ExpertiseFees"] = "expertise-fees";
    ChargeTypology["RikFees"] = "rik-fees";
    ChargeTypology["LeakageDetectionFees"] = "leakage-detection-fees";
    ChargeTypology["SecuringFees"] = "securing-fees";
    ChargeTypology["OtherFees"] = "other-fees";
})(ChargeTypology || (ChargeTypology = {}));
